import http from './http'

// 获取钱包信息
export const getWalletInfo = (uid) => {
  return http.get('/api/wallet/info', { uid: uid })
}

// 购买单集
export const buyEpisode = (uid, dramaId, episodeId) => {
  const data = {
    uid: uid,
    dramaId: dramaId,
    episodeId: episodeId
  }
  return http.post('/api/wallet/buyEpisode', data)
}

// 获取商品列表
export const getWalletProducts = () => {
  return http.get('/api/wallet/products', {})
}

// 获取支付记录
export const getPaymentRecords = (uid) => {
  return http.get('/api/wallet/paymentRecords', { uid: uid })
}

// 创建 PayPal 订单
export const createPaypalOrder = (uid, productId, url) => {
  const data = {
    uid: uid,
    productId: productId,
    payChannel: 'paypal',
    type: 1,
    url: url
  }

  return http.post('/api/wallet/paypal/createOrder', data)
}

// 捕获 PayPal 支付订单，完成金币充值
export const capturePaypalOrder = (uid, orderId, payerId, token) => {
  const data = {
    uid: uid,
    orderId: orderId,
    payerId: payerId,
    token: token
  }
  return http.post('/api/wallet/paypal/captureOrder', data)
}

// 创建 OceanPay 支付订单，返回前端需要的表单数据（含后端计算的 signValue）
export const createOceanPayOrder = (uid, productId, url, methods = 'Credit Card', billing = {}) => {
  const data = {
    uid: uid,
    productId: productId,
    url: url,
    methods: methods,
    billing_firstName: billing.billing_firstName,
    billing_lastName: billing.billing_lastName,
    billing_email: billing.billing_email
  }
  return http.post('/api/wallet/oceanpay/createOrder', data)
}

export const captureOceanPayOrder = (uid, orderNum) => {
  const data = {
    uid: uid,
    orderNum: orderNum
  }
  return http.post('/api/wallet/oceanpay/captureOrder', data)
}
